import React from 'react';
import {AvGroup} from "availity-reactstrap-validation";
import {Col, Label, Row} from "reactstrap";
import AvField from "../../shared/component/form/AvField";
import ServiceCategoryService from "../../shared/service/ServiceCategoryService"
import {STATUS} from "../../shared/utils/Constants"


const defaultServiceSubcategory= {
    id: '',
    categoryId: 1,
    name: '',
    description: '',
    requestType: '',
    status: 'A'
};
const requestType={SERVICE_REQUEST: "Hizmet Talebi", INCIDENT : "Arıza Talebi"}

export default class ServiceSubcategorySave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceSubcategory: defaultServiceSubcategory,
            serviceCategoryList:[],
            pageMode: null
        };
        this.serviceCategoryService=new ServiceCategoryService()
    }
    componentDidMount = () => {
        this.clearData();
        this.serviceCategoryService.findAll().then(response => this.setState({serviceCategoryList: response}));
    }

    render() {
        return (
            <Row className="justify-content-center">
                <Col>
                    <AvGroup>
                        <Label for="categoryId">Kategori<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="select"
                            className="form-control"
                            name="categoryId"
                            value={this.state.serviceSubcategory.categoryId}
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                }
                            }}
                            onChange={this.__handleChange}>
                        <option value='' key=''/>
                        {this.state.serviceCategoryList.map(element => (
                            <option value={element.id} key={element.id}>
                                {element.name}
                            </option>
                        ))}
                        </AvField>
                    </AvGroup>
                    <AvGroup>
                        <Label for="name">Alt Kategori<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="text"
                            className="form-control"
                            name="name"
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                },
                                minLength: {
                                    value: 1,
                                    errorMessage: 'Bu alan en az 1 karakterden oluşabilir.'
                                },
                                maxLength: {
                                    value: 255,
                                    errorMessage: 'Bu alan en fazla 255 karakterden oluşabilir.'
                                }
                            }}
                            value={this.state.serviceSubcategory.name}
                            onChange={this.__handleChange}
                        />
                    </AvGroup>
                    <AvGroup>
                        <Label for="description">Açıklama</Label>
                        <AvField
                            type="textarea"
                            className="form-control textAreaHermes"
                            name="description"
                            validate={{
                                maxLength: {
                                    value: 500,
                                    errorMessage: 'Bu alan en fazla 500 karakterden oluşabilir.'
                                }
                            }}
                            value={this.state.serviceSubcategory.description}
                            onChange={this.__handleChange}
                        />
                    </AvGroup>

                    <AvGroup>
                        <Label for="requestType">Talep Tipi<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="select"
                            className="form-control"
                            name="requestType"
                            value={this.state.serviceSubcategory.requestType}
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                }
                            }}
                            onChange={this.__handleChange}
                        >
                        <option value='' key=''/>
                        {Object.entries(requestType).map(([key,value]) => (
                                            <option value={key} key={key}>
                                                {value}
                                            </option>
                                        ))}
                        </AvField>
                    </AvGroup>
                    <AvGroup>
                        <Label for="status">Durum<span style={{color: 'red'}}> (*)</span>
                        </Label>
                        <AvField
                            type="select"
                            className="form-control"
                            name="status"
                            value={this.state.serviceSubcategory.status}
                            validate={{
                                required: {
                                    value: true,
                                    errorMessage: 'Bu alan zorunlu.'
                                }
                            }}
                            onChange={this.__handleChange}>
                        {STATUS.map(element => (
                            <option value={element.value} key={element.value}>
                                {element.name}
                            </option>
                        ))}
                        </AvField>
                    </AvGroup>
                </Col>
            </Row>
        );
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let serviceSubcategory = this.state.serviceSubcategory;
        serviceSubcategory[e.target.name] = value;
        this.setState({serviceSubcategory: serviceSubcategory});
    }

    setData = (data, pageMode) => {
        data.categoryId = data.categoryId ? data.categoryId.id : null;
        this.setState({serviceSubcategory: data, pageMode: pageMode});
    }

    getData = () => {
        return this.state.serviceSubcategory;
    }

    clearData = () => {
        this.setState({serviceSubcategory: Object.assign({}, defaultServiceSubcategory), pageMode: null});
    }

}
